export default __webpack_public_path__ + "static/media/tripadvisor.f4b1e522.svg";